import { Button } from "../../../Button/index.js";
import React from "react";
import { IconArrowLeft, IconArrowRight, IconClose } from "@synthesis/shared-icons";
import { cn } from "@synthesis/shared-utils";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/TableFiltersLine/local-components/FiltersLine/FiltersLine.tsx
const FiltersLine = ({ className, onClear, children }) => {
	const scrollLineRef = React.useRef(null);
	const containerRef = React.useRef(null);
	const [scrollLeft, setScrollLeft] = React.useState(0);
	const [layoutTick, setLayoutTick] = React.useState(0);
	const containerW = containerRef.current?.offsetWidth ?? 0;
	const lineW = scrollLineRef.current ? Array.from(scrollLineRef.current.children).reduce((acc, child) => acc + child.offsetWidth, 0) + Math.max(0, (scrollLineRef.current.children.length - 1) * 8) : 0;
	const lineSizeDiff = Math.max(0, lineW - containerW);
	const isAllButtonsHidden = lineW <= containerW;
	const isLeftButtonHidden = isAllButtonsHidden || scrollLeft === 0;
	const isRightButtonHidden = isAllButtonsHidden || scrollLeft >= lineSizeDiff;
	React.useLayoutEffect(() => {
		const container = containerRef.current;
		if (!container) return;
		const observer = new ResizeObserver(() => setLayoutTick((value) => value + 1));
		observer.observe(container);
		return () => observer.disconnect();
	}, []);
	React.useEffect(() => {
		setLayoutTick((value) => value + 1);
	}, [children]);
	const handleLeftScrollClick = () => {
		if (scrollLeft > 0) {
			const nextScroll = scrollLeft - containerW / 2;
			setScrollLeft(nextScroll > 0 ? nextScroll : 0);
		}
	};
	const handleRightScrollClick = () => {
		if (scrollLeft < lineSizeDiff) {
			const nextScroll = scrollLeft + containerW / 2;
			setScrollLeft(nextScroll < lineSizeDiff ? nextScroll : lineSizeDiff);
		}
	};
	return /* @__PURE__ */ jsxs("div", {
		className: cn("flex w-full flex-nowrap items-center gap-4 pr-1", className),
		children: [/* @__PURE__ */ jsxs("div", {
			className: "relative flex-1 overflow-hidden",
			ref: containerRef,
			children: [
				/* @__PURE__ */ jsx("div", {
					className: "absolute left-0 top-0 z-20 flex h-full w-12 items-center transition-all data-[hidden=true]:hidden",
					"data-hidden": isLeftButtonHidden,
					children: /* @__PURE__ */ jsx(Button, {
						className: "ml-1",
						theme: "elevated",
						size: "xs",
						icon: /* @__PURE__ */ jsx(IconArrowLeft, { className: "text-type-minor size-5" }),
						onClick: handleLeftScrollClick
					})
				}),
				/* @__PURE__ */ jsx("div", {
					className: "flex flex-nowrap items-center gap-2 transition-all",
					ref: scrollLineRef,
					style: { transform: `translateX(${scrollLeft * -1}px)` },
					children
				}),
				/* @__PURE__ */ jsx("div", {
					className: "absolute right-0 top-0 z-20 flex h-full w-12 items-center data-[hidden=true]:hidden",
					"data-hidden": isRightButtonHidden,
					children: /* @__PURE__ */ jsx(Button, {
						className: "ml-auto mr-1",
						theme: "elevated",
						size: "xs",
						icon: /* @__PURE__ */ jsx(IconArrowRight, { className: "text-type-minor size-5" }),
						onClick: handleRightScrollClick
					})
				})
			]
		}), /* @__PURE__ */ jsx(Button, {
			theme: "text",
			size: "xs",
			leftIcon: /* @__PURE__ */ jsx(IconClose, { className: "text-neutrals-60 size-5" }),
			onClick: onClear,
			children: "Сбросить"
		})]
	});
};
//#endregion
export { FiltersLine };

//# sourceMappingURL=FiltersLine.js.map